/** Post-approve auto-advance countdown (seconds). */
export const COUNTDOWN_SECONDS = 3;
